/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AskHealthReport } from '../models/AskHealthReport';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminAskHealthService {

    /**
     * Get Ask Health
     * Ask health by Monday-start UTC week, oldest first (superuser-only).
     * @param weeks
     * @returns AskHealthReport Successful Response
     * @throws ApiError
     */
    public static getAskHealthApiV1AdminAskHealthGet(
        weeks: number = 8,
    ): CancelablePromise<AskHealthReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/ask-health',
            query: {
                'weeks': weeks,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
